/* eslint-disable */
<template>
  <section class="ncd-top-container">
    <div
      class="ncd-top-search-container"
      :class="{
        'ncd-top-search-container-radius-unset': $route.name != 'NewHomepage',
      }"
    >
      <section class="d-flex align-items-center w-100">
        <div class="position-relative d-flex side-nav-main">
          <img
            src="../../assets/NewDashboard/Mobiledesign/menuicon.svg"
            alt=""
            class="ncd-menu-icon"
            @click="showsidebar = !showsidebar"
          />
          <div
            class="mh-side-nav"
            @focusout="showsidebar = false"
            :class="{
              mhfixedwidth: showsidebar,
              mhtrans: !showsidebar,
            }"
          >
            <MainLeftpart
              :expanded="showsidebar"
              @navigate="showsidebar = false"
            />
          </div>
        </div>
        <!-- <div class="w-75 ms-3">
          <div class="fw-700 font-inter text-white fs-16">
            Hi {{ firstName }}!
            <img
              src="../../assets/NewDashboard/Mobiledesign/lightbluearw.svg"
              alt=""
            />
          </div>
          <div
            class="font-inter fw-500 color-E0E0E0 w-100 d-flex align-items-center"
          >
            <div class="w-40 text-truncate">{{ jobTitle }}</div>
            •
            <div class="w-40 text-truncate">{{ location }}</div>
          </div>
        </div> -->
        <!-- <div class="earned-coins fw-800 fs-12 font-inter color-8A5A00 ml-1">
					<img src="../../assets/NewDashboard/Mobiledesign/coin.svg" alt="" />
					4.1k
				</div> -->
        <div class="fw-600 text-white font-inter fs-20 w-75 ms-3">
          {{ $route.meta.title }}
        </div>
        <div
          class="ml-2 ncd-notification-wrap pointer"
          @click="openSearchDropdown"
        >
          <img
            src="../../assets/NewDashboard/Mobiledesign/searchmob.svg"
            alt=""
          />
        </div>
        <div class="ms-2 pointer" @click="gotoNotifications">
          <img
            :src="
              notificationCount > 0
                ? require('../../assets/NewDashboard/Mobiledesign/notification.svg')
                : require('../../assets/NewDashboard/Mobiledesign/notiNoRed.svg')
            "
            alt="Notifications"
          />
        </div>
      </section>
      <section
        v-if="$route.name == 'NewHomepage'"
        class="ncd-top-search-input position-relative mt-16px pointer"
        @click="openSearchDropdown"
      >
        <img
          src="../../assets/NewDashboard/Mobiledesign/newsearch.svg"
          class="ncd-search-img-pos"
          alt=""
        />
        <b-form-input
          placeholder="Search for jobs, skills, companies..."
          readonly
          @click="openSearchDropdown"
          @focus="openSearchDropdown"
        ></b-form-input>
      </section>
    </div>

    <!-- Search Dropdown Section (copied from MobileHeader.vue) -->
    <div v-show="searchActive" class="search-suggestion-container">
      <img
        id="hideinmobile"
        @click="closeSearchDropdown"
        class="hp-whitecross-pos pointer"
        src="@/assets/img/icons/whitecross.svg"
        alt=""
      />
      <!-- Expanded Search Container -->
      <div class="header-center-area">
        <!-- Tabs -->
        <div class="search-tabs-container">
          <div
            class="search-tab"
            @click="selectTab('job')"
            :class="selectedTab == 'job' ? 'active' : ''"
          >
            Jobs
          </div>
          <span class="divider">|</span>
          <div
            class="search-tab"
            @click="selectTab('assessment')"
            :class="selectedTab == 'assessment' ? 'active' : ''"
          >
            Assessments
          </div>
          <span class="divider">|</span>
          <div
            class="search-tab"
            @click="selectTab('course')"
            :class="selectedTab == 'course' ? 'active' : ''"
          >
            Courses
          </div>
        </div>

        <!-- Search Bar -->
        <div class="search-bar-wrapper is-active">
          <div class="d-flex gap-2 w-100">
            <img
              id="hideinlaptop"
              class="shadow pointer"
              src="@/assets/guestHeader/search-back.svg"
              alt="Close Search"
              @click="closeSearchDropdown"
            />
            <div class="header-search" @click="$refs.searchInput.focus()">
              <b-form-input
                placeholder="Search.."
                v-model="searchQuery"
                ref="searchInput"
                @input="onSearchInput"
                @keyup.enter="handleEnterSearch"
              ></b-form-input>
              <img src="@/assets/guestHeader/searchBar.svg" alt="Search Icon" />
            </div>
          </div>

          <!-- Search Dropdown Content Component -->
          <SearchDropdown
            :isVisible="searchActive"
            :selectedTab="selectedTab"
            @close-modal="closeSearchDropdown"
            @open-resume-clinic="openResumeClinicModal"
            :searchQuery="searchQuery"
            :searchSuggestion="searchSuggestion"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
/* eslint-disable */
import { appConfig } from "@/config/appConfig";
import header from "@/views/mixin/header";
import MainLeftpart from "./MainLeftpart.vue";
import SearchDropdown from "@/components/fixedComponents/SearchDropdown.vue";
import globalSearchMixin from "@/utils/mixins/globalSearchMixin";
import { getNotificationData } from "@/utils/apiFunctions";
import { getProcessedToken } from "@/utils/request";
export default {
  name: "NcdTopContainer",
  mixins: [header, globalSearchMixin],
  data() {
    return {
      showsidebar: false,
      openjoboptions: false,
      showTraining: true,
      searchActive: false,
      selectedTab: "job",
      searchQuery: "",
      searchSuggestion: [],
      notificationCount: 0,
      userID: null,
      baseUrl: `${appConfig.candidateBase}/`,
    };
  },
  components: {
    MainLeftpart,
    SearchDropdown,
  },
  mounted() {
    document.body.addEventListener("click", this.handleClickOutside);
    this.userID = getProcessedToken();
    this.fetchNotificationCount();
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.handleClickOutside);
  },
  watch: {
    $route() {
      this.closeSearchDropdown();
      // Refresh the notification badge when navigating back from the notifications page
      this.fetchNotificationCount();
    },
  },
  props: {
    firstName: {
      type: String,
      default: "Firstname",
    },
    jobTitle: {
      type: String,
      default: "Product Designer",
    },
    location: {
      type: String,
      default: "New Yorkk",
    },
    recruitersCount: {
      type: [Number, String],
      default: 6,
    },
  },
  methods: {
    switchToCandidate(path) {
      const queryPrefix = path.includes("?") ? "&" : "?";
      window.open(
        `${this.baseUrl}${path}${queryPrefix}from=candidate`,
        "_self",
      );
    },
    handleClickOutside(event) {
      const sidebar = document.querySelector(".side-nav-main");
      if (sidebar && !sidebar.contains(event.target)) {
        this.showsidebar = false;
      }
    },
    gotoNotifications() {
      this.$router.push({ name: "notifications" });
    },
    async fetchNotificationCount() {
      try {
        const payload = {
          userID: this.userID,
          count: 1,
          page: 0,
          order: -1,
        };
        const res = await getNotificationData(payload);
        if (res.status === 200) {
          this.notificationCount = res.data.data.totalCount;
        }
      } catch (error) {
        console.error("Failed to fetch notification count:", error);
      }
    },
    openSearchDropdown() {
      this.searchActive = true;
      this.selectedTab = "job";
    },
    selectTab(tab) {
      this.selectedTab = tab;
      this.searchQuery = "";
      this.searchSuggestion = [];
    },
    closeSearchDropdown() {
      this.searchActive = false;
      this.selectedTab = "job";
      this.searchQuery = "";
      this.searchSuggestion = [];
    },
    openResumeClinicModal() {
      // Resume Clinic modal is handled by the guest header / parent
    },
  },
};
</script>

<style scoped>
.w-40 {
  width: 40%;
}
@media (max-width: 1028px) {
  .eyeicon-shadow {
    width: 22px;
    height: 22px;
    background: #ffffff;
    border: 1px solid #e9e9e9;
    box-shadow: 0px -2px 5px rgba(255, 255, 255, 0.9),
      0px 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 16px;
    margin-bottom: 2px;
  }
}
@media (max-width: 1028px) {
  .ncd-top-firstcard {
    padding: 10px 0px 10px 16px;
    height: 42px;
    background: linear-gradient(
        90deg,
        rgba(32, 99, 155, 0.04) 0%,
        rgba(11, 34, 53, 0.04) 78.8%
      ),
      #ffffff;
  }
  .ncd-top-search-container {
    padding: 16px;

    background: linear-gradient(
      67.34deg,
      #073787 0.46%,
      #073583 30.97%,
      #083078 58.08%,
      #0a2765 85.2%,
      #0c1c4b 111.18%,
      #0d1b49 113.44%
    );
    border-radius: 0px 0px 24px 24px;
  }
  .earned-coins {
    padding: 0 3px 0 2px;
    background: linear-gradient(
        294.58deg,
        rgba(255, 248, 217, 0.54) 18.18%,
        rgba(255, 232, 163, 0.54) 50%,
        rgba(247, 201, 104, 0.54) 81.82%
      ),
      #ffffff;
    border: 1px solid #f1d27a;
    box-shadow: 0px 4px 10px rgba(184, 135, 36, 0.12);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ncd-search-img-pos {
    position: absolute;
    left: 16px;
    top: 10px;
  }
}
.color-2E452D {
  color: #2e452d;
}
.color-E0E0E0 {
  color: #e0e0e0;
}
.color-8A5A00 {
  color: #8a5a00;
}
.ncd-top-search-input .form-control {
  padding: 0px 16px 0 42px;
  height: 38px;
  background: #ffffff;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.101961);
  border-radius: 12px;
}
.ncd-top-search-input .form-control::placeholder {
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #94a3b8;
}
.ncd-menu-icon {
  cursor: pointer;
}

@media (max-width: 1028px) {
  .ncd-top-container {
        padding-top: env(safe-area-inset-top);
  }
  .hedaer-down-border {
    margin: 0 15px 0 16px;
    width: 92%;
    border-top: 3px solid transparent;
    border-image: repeating-linear-gradient(
        to right,
        #efefef 0,
        #efefef 12px,
        transparent 12px,
        transparent 18px
      )
      1;
  }
  .padding16px {
    padding: 16px;
  }
  .mh-side-nav {
    position: fixed;
    top: calc(0px + env(safe-area-inset-top));
    left: -3px;
    width: 0px;
    height: 100dvh;
    box-shadow: 9px 4px 13px 0px #0000001a;
    z-index: 1500;
    overflow: hidden;
    background: linear-gradient(134.23deg, #ffffff 5.69%, #ebf0fc 96.31%);
    border: 1.5px solid #e9e9e9;
    border-radius: 0px 36px 36px 0px;
    padding-bottom: env(safe-area-inset-bottom);
  }
  .mh-side-nav .mlp-root {
    width: 100% !important;
    min-height: 100%;
    padding: 16px;
    box-sizing: border-box;
  }
  .mh-side-nav .mlp-root.expanded {
    width: 100% !important;
    height: calc(100dvh - 46px);
    overflow: auto;
  }
  .mh-side-nav:hover {
    width: 215px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .mhfixedwidth {
    width: 285px !important;
    padding: 16px;
  }
  .mhtrans {
    width: 0px !important;
  }
  .mh-side-menu-main li img {
    padding-right: 10px;
    cursor: pointer;
  }
  .mh-side-menu-main li {
    margin: 12px;
  }
  .mh-side-menu-main {
    padding-left: 0px;
    overflow-y: auto;
    overflow-x: hidden;
    height: calc(100dvh - 20px);
  }
  .mh-activenavclass-back {
    background-color: #eef3f7;
    border-radius: 4px;
    padding: 7px 8px;
  }
  .mh-inactivenavclass-back {
    background-color: transparent;
    border-radius: 15px;
    padding: 7px 8px;
  }
  .mh-activenavclass-dropdown {
    background-color: transparent;
    border-radius: 4px;
    padding: 7px 8px;
    color: #20639b !important;
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    font-weight: 600;
  }
  .mh-inactivenavclass-dropdown {
    background-color: transparent;
    border-radius: 15px;
    padding: 7px 8px;
    color: #324054 !important;
    font-family: "Montserrat", sans-serif;
    font-size: 14px;
    font-weight: 500;
  }
  .mh-selected-suboption {
    background: #20639b14;
    font-family: "Montserrat", sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: #20639b;
    border-radius: 4px;
    padding: 7px 10px;
    margin: 2px 0;
    position: relative;
  }
  .mh-unselected-suboption {
    background: transparent;
    font-family: "Montserrat", sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: #344054;
    border-radius: 4px;
    padding: 7px 10px;
    margin: 2px 0;
  }
  .sel-line-sidebar {
    position: absolute;
    height: 100%;
    background-color: silver;
    width: 2px;
    border-radius: 4px;
    left: -18px;
    top: 0;
  }
}
</style>

<!-- Search overlay styles copied verbatim from MobileHeader.vue (kept global, no changes) -->
<style>
.shadow {
  border-radius: 50%;
}
.pointer {
  cursor: pointer;
}
.search-suggestion-container .header-search {
  padding: 2px !important;
}
.search-suggestion-container {
  position: fixed;
  top: calc(0px + env(safe-area-inset-top));
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 2069;
  background: #f7f7f7;
  overflow-y: auto;
}
.search-suggestion-container .header-center-area {
  position: relative;
  width: 100%;
  padding: 15px 5px;
  pointer-events: auto;
  height: fit-content;
}
.search-suggestion-container .search-tabs-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c4dcf6;
  border-radius: 74px;
  padding: 5px 6px;
  gap: 15px;
  background-color: white;
  margin-bottom: 10px;
  opacity: unset;
  width: 100%;
}
.search-suggestion-container .search-tab {
  font-size: 16px;
  color: #4a7eff;
  cursor: pointer;
  font-weight: 400;
  padding: 4px 8px;
  border-radius: 30px;
  transition: all 0.2s;
  line-height: 2;
}
.search-suggestion-container .search-tab.active {
  background: #4a7eff;
  color: white;
}
@media (max-width: 1028px) {
  .search-suggestion-container .search-tabs-container {
    width: 95%;
    gap: 10px;
  }
  .search-suggestion-container .search-tab {
    font-size: 16px;
    padding: 4px 0;
    flex: 1;
    text-align: center;
  }
  .explore-icon img {
    height: 75px;
  }
}
.search-suggestion-container .header-search {
  border: 1.5px solid #efefef;
  border-radius: 74px;
  position: relative;
  width: 100%;
  padding: 10px;
  background: white;
  flex: 1;
  box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.02), 0px 2px 2px rgba(0, 0, 0, 0.03),
    0px 0px 1px rgba(0, 0, 0, 0.03);
}
.search-suggestion-container .header-search img {
  position: absolute;
  left: 19px;
  top: 14px;
}
.search-suggestion-container .header-search .form-control {
  border: none;
  padding: 0.375rem 0.75rem 0.375rem 42px;
  border-radius: 50px;
}
.search-suggestion-container .header-search .form-control:focus {
  box-shadow: none;
}
.search-suggestion-container .search-bar-wrapper {
  position: fixed;
  padding: 15px;
  background-color: #ffffff;
  pointer-events: auto;
  box-shadow: 133px 38px 56px rgba(0, 0, 0, 0.01),
    75px 22px 47px rgba(0, 0, 0, 0.05), 33px 10px 35px rgba(0, 0, 0, 0.09),
    8px 2px 19px rgba(0, 0, 0, 0.1);
  border-radius: 20px 20px 0 0;
}
.search-suggestion-container .search-bar-wrapper.is-active {
  top: calc(78px + env(safe-area-inset-top));
  max-width: 95%;
  width: 95%;
  left: 11px;
}
.search-suggestion-container .search-dropdown-content {
  width: 100%;
  left: 50%;
  padding: 0px;
  padding-right: 2px;
  margin-top: 0px;
  box-shadow: none;
  min-height: unset;
  max-height: unset;
  max-height: calc(100dvh - 168px);
  max-height: calc(100dvh - 168px);
  overflow: hidden auto;
  border-radius: 0 0 20px 20px;
  box-shadow: 133px 38px 56px -30px rgba(0, 0, 0, 0.01),
    75px 22px 47px -25px rgba(0, 0, 0, 0.05),
    33px 10px 35px -20px rgba(0, 0, 0, 0.09),
    8px 2px 19px -10px rgba(0, 0, 0, 0.1);
}
</style>
